/**
 * @description service
 * @media_type string, 资源类型
 * const MEDIA_TYPE_AUDIO = 'audio';
 * const MEDIA_TYPE_IMAGE = 'image';
 * const MEDIA_TYPE_IMAGE_FULLTEXT = 'imagefulltext';
 * const MEDIA_TYPE_IMAGE_WALL = 'imagewall';
 * const MEDIA_TYPE_IMAGE_WEIKE = 'imageweike';
 * const MEDIA_TYPE_VIDEO = 'video';
 * const MEDIA_TYPE_VIDEO_WEIKE = 'videoweike';
 * const MEDIA_TYPE_DOC_WEIKE = 'docweike';
 * const MEDIA_TYPE_PIC_WEIKE = 'picweike';
 * const MEDIA_TYPE_AI_LOG_FILE = 'ailogfile';
 * const MEDIA_TYPE_GRAFFITI = 'graffiti';  //涂鸦数据
 */

/**
 * @media_type string, 资源类型
 * @id_prefix	是	对象前缀
 * const ID_PREFIX_ENTERPRISE = 'enterprise';
 * const ID_PREFIX_SESSION = 'session';
 * const ID_PREFIX_STUDENT = 'student';
 * const ID_PREFIX_TEACHER = 'teacher';
 * const ID_PREFIX_HELPCENTER = 'helpcenter';
 * @id	否	对象ID
 * @ext	是	文件后缀名
 * @return {
 * "error_code": 0,
 * "error_message": "",
 *  "data": {
 *      "sp": 1, // 服务提供商，1. 百度；2. AWS ,
 *      "path": "docweike/teacher/weike/25L634e/1570711647.1271.57821.1571.docx",
 *      "resource_id": 1571,
 *      "prefix": "bj.bcebos.com",
 *      "bucket": "umu-pd",
 *      "timestamp": 1570711647
 *   }
 * }
 */
var request = require('./request');
var requestV2 = require('./requestV2');
var logger = require('./logger');
var executeWithRetry = require('./utils/retry');
var { MAX_RETRIES, RETRY_DELAY } = require('./constants/retry');

function getUploadObj(params) {
    return executeWithRetry(
        async () => {
            return requestV2
                .get(
                    '/uapi/v1/ufs/get-upload-obj',
                    Object.assign(
                        {
                            id_prefix: 'teacher',
                        },
                        params
                    )
                )
                .then(function (response) {
                    return response && response.data;
                });
        },
        { retries: MAX_RETRIES, retryDelay: RETRY_DELAY, taskName: 'getUploadObj' }
    ).catch(function (e) {
        logger.errorAndLog('[umu-upload] getUploadObj error:', e, params);
        throw e;
    });
}

/**
 * @sp	是	int，服务提供商 1. 百度 2. AWS
 * @resource_id	否	资源ID
 * @media_type string, 资源类型
 * @file_name	是	string, 文件名
 * @file_size	是	int, 文件大小
 * @path	是	string, 资源路径
 * @ext	是	文件后缀名
 * @extend_info	否	json, 扩展信息

 * @return { "error_code": 0, "error_message": "", "data": { "result": 1, "resource_id": "1474" }}
 */
// v1 版本不能正确返回报错信息，保留 v1 版本，兼容现有业务，新业务使用 v2 版本
function uploadCallback(params) {
    return request
        .get('/uapi/v1/ufs/upload-callback', params)
        .then(function (response) {
            return response && response.data;
        })
        .catch(function (e) {
            logger.error('[umu-upload] uploadCallback error:', e, params);
            throw e;
        });
}

// v2 版本, 修复 v1 版本不能正确返回报错信息的问题，增加重试机制
function uploadCallbackV2(params) {
    return executeWithRetry(
        async () => {
            return requestV2.get('/uapi/v1/ufs/upload-callback', params).then(function (response) {
                return response && response.data;
            });
        },
        { retries: MAX_RETRIES, retryDelay: RETRY_DELAY, taskName: 'uploadCallbackWithRetry' }
    ).catch(function (e) {
        logger.error('[umu-upload] uploadCallbackWithRetry error:', e, params);
        throw e;
    });
}

function assumerole(region) {
    var params = {};
    if (region) {
        params = { region: region };
    }
    return executeWithRetry(
        async () => {
            return requestV2.get('/napi/aws/assumerole', params).then(function (response) {
                return response && response.data;
            });
        },
        { retries: MAX_RETRIES, retryDelay: RETRY_DELAY, taskName: 'assumerole' }
    ).catch(function (e) {
        logger.error('[umu-upload] assumerole error:', e, params);
        throw e;
    });
}

function isInWhiteList() {
    const params = { type: 2 };
    return request
        .get('/uapi/v1/user/in-white-list', params)
        .then(function (response) {
            return response && response.data;
        })
        .catch(function (e) {
            logger.error('[umu-upload] isInWhiteList error:', e, params);
            throw e;
        });
}

module.exports = {
    getUploadObj: getUploadObj,
    uploadCallback: uploadCallback,
    uploadCallbackV2: uploadCallbackV2,
    assumerole: assumerole,
    isInWhiteList: isInWhiteList,
};
